import { render, staticRenderFns } from "./buyhexDialog.vue?vue&type=template&id=009f0628"
import script from "./buyhexDialog.vue?vue&type=script&lang=js"
export * from "./buyhexDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports